export default __webpack_public_path__ + "static/media/PixelPicks.15935c27.png";